import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseDataService } from './base-data.service';

@Injectable({
  providedIn: 'root'
})
export class DataService extends BaseDataService {

  constructor(private http: HttpClient) {
    super();
  }

  test(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/test`);
  }
}
